import baseApi, {provideTag} from 'store/slices/api/baseApi'
import {convertToUrlParams} from 'utils'

const invitesApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getInvites: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `invites${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('Invite'),
        }),
        getInvite: build.query({
            query: (id) => {
                return {
                    url: `invites/${id}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('Invite', result),
        }),
        deleteInvite: build.mutation({
            query: (id) => {
                return {
                    url: `invites/${id}`,
                    method: 'DELETE',
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Invite'],
        }),
        createInvite: build.mutation({
            query: (data) => {
                return {
                    url: `invites`,
                    method: 'POST',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Invite'],
        }),
        editInvite: build.mutation({
            query: (data) => {
                return {
                    url: `invites/${data._id}`,
                    method: 'PUT',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Invite'],
        }),
        sendAgain: build.mutation({
            query: (id) => {
                return {
                    url: `invites/send-again/${id}`,
                    method: 'POST',
                }
            },
        }),
    }),
    overrideExisting: false,
})

export default invitesApi

export const {
    useGetInvitesQuery,
    useGetInviteQuery,
    useDeleteInviteMutation,
    useCreateInviteMutation,
    useEditInviteMutation,
    useSendAgainMutation,
} = invitesApi
